module.exports = __webpack_public_path__ + "img/table-columns.dd2041af.svg";